/* eslint-disable @typescript-eslint/no-unused-vars */

import React, { useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import './AdvanceRuleEngineForm.css';
import { CheckBox, CustomBreadCrumbs, CustomButtonGroup, CustomInput, CustomRadioForm, CustomSwitch, DashboardHeader, DashboardLoader, FilterProp, RadioButton, SelectDropDown, SidePopover, TableSubHeader, useAppDispatch, useAppSelector } from '../../globalUtils/globalExports';
import { useLocation, useNavigate } from 'react-router-dom';
import { advanceRuleEngineCreateRule, advanceRuleEngineUpdateLogs, advanceRuleEngineUpdateRule, clearAdvanceRuleEngineFormRedux, fetchAdvanceRuleEngineRule, fetchChargerLocationReferenceData, fetchChargerProductTypeReferenceData, fetchChargersByCustomersByOrg, fetchChargerStationReferenceData, fetchCustomerReferenceData, fetchSoftwarVersionReferenceData, fetchUsersReferenceData, getAdvanceRuleEngineReducer, getCurrentScreenAppliedFiltersCount, getReferenceDataReducer, getUserReducer, setAdvanceRuleEngineFormRedux, setAdvanceRuleEngineListTableProps } from '../../rmsReduxStore/reduxExports';
import CustomForm, { ICustomFormProps, IFormContentProp } from '../../globalUtils/CustomForm/CustomForm';
import { checkValidAlphaNumericAndSymbols, createBreadCrumbProps, keyPressValidationAlphaNumericAndSymbols, renderHeaderActionButtons, useEffectOnce } from '../../globalUtils/globalHooks';
import { cloneDeep,isEqual } from 'lodash';
import { Icon, IconWithTooltip } from '../../globalUtils/globalIcons';
import { Typography } from '@mui/material';
import { ThreeDots } from 'react-loader-spinner';
import ExecutionPlanButton from './ExecutionPlanButton';
import { Id, toast } from 'react-toastify';
import { IAdvanceRuleEngineFormRedux, IUpdateLogs } from '../../rmsReduxStore/advanceRuleEngineRedux/advanceRuleEngineType';
import ExecutionSummaryPopover from './ExecutionSummaryPopover';
// import TriggerLogsPopover from './TriggerLogsPopover';
import { ExecutionPlan } from '../componentExports';
import UpdateLogsSidePopover from './UpdateLogsSidePopover';




const initialFormData: IAdvanceRuleEngineFormRedux = {
  name: null,
  description: null,
  chargerIds: null,
  id: null,
  status: 'Disabled',
  draftStatus: null,
  executionPlan: null,
  autoAssign: 'Disabled',
  imageURL: '',
  fileName: '',
  runningStatus: null,
  executionThreshold: 50,
  resetTimePeriod: null,
  resetTimeUnit: null,
  autoAssignCustomerIds: [],
  autoAssignProductTypeIds: []
}

export const getOrgId = () => {
  return JSON.parse(localStorage.getItem('rms-user') || '{}')?.orgId;
}

export const getRoleId = () => {
  return JSON.parse(localStorage.getItem('rms-user') || '{}')?.roleId
}

const AdvanceRuleEngineForm: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const { userRoleTypeReferenceData } = useAppSelector(getReferenceDataReducer);
  const { chargerListByCustomerByOrg } = useAppSelector(getUserReducer);
  const { chargerLocationReferenceData, chargerProductTypeReferenceData, chargingStationReferenceData, softwareVersionReferenceData, customerReferenceData } = useAppSelector(getReferenceDataReducer);
  const { advanceRuleEngineFormRedux,advanceRuleEngineListTableProps } = useAppSelector(getAdvanceRuleEngineReducer);
  const [advanceRuleFormData, setAdvanceRuleFormData] = useState<IAdvanceRuleEngineFormRedux>(initialFormData);
  const initialRuleFormDataRef  = useRef<IAdvanceRuleEngineFormRedux>(initialFormData);
  const advanceRuleFormDataRef = useRef<IAdvanceRuleEngineFormRedux>(initialFormData);
  const [showLoader, setShowLoader] = useState(false);
  const [exportAnchorEl, setExportAnchorEl] = useState<HTMLElement | null>(null);
  const [mode, setMode] = useState(location?.state?.mode ? location?.state?.mode : 'Define')
  const [chargersChipValues, setChargersChipValues] = useState<string[]>([]);
  const [chargerCheckboxStates, setChargerCheckboxStates] = useState<string[]>([]);
  const [selectedRadioOption, setSelectedRadioOption] = useState('SelectChargers');
  const [initialExecutionPlan, setInitialExecutionPlan] = useState<ExecutionPlan | null>(null);
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  const [selectedChargers, setSelectedChargers] = useState<string[]>([]);
  const [isSelectAllChargersChecked, setIsSelectAllChargersChecked] = useState(false);
  const [disableExecutionPlanButton, setDisableExecutionPlanButton] = useState(true);
  const [initialAutoAssignState, setInitialAutoAssignState] = useState('Disabled');
  const [errorMessageName, setErrorMessageName] = useState('');
  const [errorMessageDescription, setErrorMessageDescription] = useState('');
  const [dataList, setDataList] = useState<string[]>([]);
  const [selectedRadioOptionForStatus, setSelectedRadioOptionForStatus] = useState(advanceRuleEngineFormRedux?.status ? advanceRuleEngineFormRedux?.status : 'Disabled');
  const [selectedChargersInitially, setSelectedChargersInitially] = useState<string[]>([]);
  const [isExecutionSummarySidePopoverOpen,setIsExecutionSummarySidePopoverOpen] = useState<boolean>(false);
  const [isUpdateLogsSidePopoverOpen,setIsUpdateLogsSidePopoverOpen] = useState<boolean>(false);
  // const [isTriggerLogsSidePopoverOpen,setIsTriggerLogsSidePopoverOpen] = useState<boolean>(false);
  const [isSidePopoverExpanded,setIsSidePopoverExpanded] = useState<boolean>(false);
  const [executionSummaryFiltersVisible, setExecutionSummaryFiltersVisible] = useState(false);
  const [showAllTriggers, setShowAllTriggers] = useState<boolean>(false);
  // const [triggerLogsFiltersVisible, setTriggerLogsFiltersVisible] = useState(false);
  // const [triggerLogsExportAnchorEl, setTriggerLogsExportAnchorEl] = useState<HTMLElement | null>(null);
  const [updateLogs, setUpdateLogs] = useState<IUpdateLogs[]>([]);
  const [cbErrorMessage,setCbErrorMessage] = useState<string>('');
  const [resetPeriodErrorMessage,setResetPeriodErrorMessage] = useState<string>('');
  const [resetPeriodToggle,setResetPeriodToggle] = useState<boolean>(advanceRuleEngineFormRedux?.resetTimePeriod != null);

  const orgId = getOrgId();


  const [filters, setFilters] = useState<InnerFilterState[]>(
    [
      {
        key: 'customer',
        value: null
      },
      {
        key: 'chargingStationId',
        value: null
      },
      {
        key: 'productType',
        value: null
      },
      {
        key: 'location',
        value: null
      },
      {
        key: 'softwareVersion',
        value: null
      }
    ]
  );

  const resetTimeUnitRef =  useMemo(()=>[
    {id:'minute',label: 'Minute', name: 'Minute', value: 'minute'},
    {id:'hour',label: 'Hour', name: 'Hour', value: 'hour'},
    {id:'day',label: 'Day', name: 'Day', value: 'day'},
  ],[]);

  const resetPeriodToggleConfig = useMemo(()=>({
    checked: resetPeriodToggle,
    switchLabelName: null,
    disableSwitchLabelName: null,
    handleClick: () => {
      const val = resetPeriodToggle;
      if(val) {
        const formData = cloneDeep(advanceRuleFormDataRef?.current);
        formData.resetTimePeriod = null;
        formData.resetTimeUnit = null;
        advanceRuleFormDataRef.current = formData;
        setAdvanceRuleFormData(formData);
        setResetPeriodErrorMessage('');
        /// dispatch an event to save all the formdata inside the redux
        dispatch(setAdvanceRuleEngineFormRedux(formData));
      }
      setResetPeriodToggle(!val);
    },
    isDisabled: mode === 'View'
  }),[resetPeriodToggle,mode])

  const handleFormDataChange = useCallback((val, formKey) => {
    const formData = cloneDeep(advanceRuleFormDataRef?.current);

    if (val?.id) {
      formData[formKey] = val?.id;
    }
    else {
      formData[formKey] = val;
    }
    if (formKey == 'name') {
      if (val.length > 90) {
        setErrorMessageName('Max characters allowed are 90')
      }
      else setErrorMessageName('')
      formData[formKey] = formData[formKey].charAt(0).toUpperCase() + formData[formKey].slice(1);
    }
    if (formKey == 'description') {
      if (val.length > 500) {
        setErrorMessageDescription('Max characters allowed are 500')
      }
      else setErrorMessageDescription('')
      formData[formKey] = formData[formKey].charAt(0).toUpperCase() + formData[formKey].slice(1);
    }
    if (formKey == 'resetTimePeriod' && val == null) {
      formData['resetTimeUnit'] = null;
    }
    if( formKey == 'autoAssign' && val == 'Disabled') {
      formData['autoAssignCustomerIds'] = [],
      formData['autoAssignProductTypeIds'] = []
    }
    advanceRuleFormDataRef.current = formData;
    setAdvanceRuleFormData(formData);

    /// dispatch an event to save all the formdata inside the redux

    dispatch(setAdvanceRuleEngineFormRedux(formData));

  }, []);


  const breadCrumbs = createBreadCrumbProps({
    breadCrumbProps:
      [
        {
          objectType: 'link',
          id: 'advanceRuleEngineDashboard',
        },
        {
          objectType: 'text',
          id: 'text',
          text: advanceRuleFormData?.name ?? ''
        }
      ]
  });

  const userFormSuccessToast = (): Id => toast.success(mode === 'Edit' ? 'Rule Edited.' : 'Rule Added.');
  const formErrorToast = (msg) : Id => toast.error(msg);



  const advanceRuleFormArray: IFormContentProp[] = useMemo(()=>[
    {
      rowCountClassName: 'grid-2',
      sectionHeading: '',
      formObject: [
        {
          formLabel: 'Rule Name',
          isRequired: true,
          objectType: 'input',
          selectDropdownProps: null,
          inputProps: {
            inputPlaceHolder: 'Type here',
            handleInputChange: (event): void => {
              handleFormDataChange(checkValidAlphaNumericAndSymbols(event?.target?.value), 'name');
            },
            inputValue: advanceRuleFormData?.name ?? '',
            inputType: 'string',
            inputFieldId: 'add_rule_name',
            isRequired: false,
            isDisabled: mode === 'View',
            autoFocus: true,
            errorMessage: errorMessageName,
            handleKeyPress: keyPressValidationAlphaNumericAndSymbols,

          },
          textAreaProps: null,
        }
      ],
    },
    {
      rowCountClassName: 'grid-2',
      sectionHeading: '',
      formObject: [
        {
          formLabel: 'Description',
          isRequired: true,
          objectType: 'text-area',
          selectDropdownProps: null,
          inputProps: null,
          textAreaProps: {
            inputPlaceHolder: mode !== 'View' ? 'Type here' : '',
            handleInputChange: (event): void => {
              handleFormDataChange(event?.target?.value, 'description');
            },
            isRequired: false,
            inputValue: advanceRuleFormData?.description ?? '',
            inputFieldId: 'description',
            isDisabled: mode === 'View',
            className: 'custom-resize',
            errorMessage: errorMessageDescription
          },
        },
      ],
    },
  ],[advanceRuleFormData?.name,advanceRuleFormData?.description,mode, errorMessageName,errorMessageDescription]);

  const chargerListCallback = useCallback((orgId, filters?, searchTerm?) => {
    let filtersToBeSent: Filters[] = []
    if (filters && filters?.length > 0) {
      filtersToBeSent = filters?.map((item) => {
        return {
          key: item.key,
          values: item.value?.map((item) => item.id) || []
        }
      })
    }
    dispatch(fetchChargersByCustomersByOrg({
      orgId: orgId,
      filters: filters ? filtersToBeSent : [],
      searchTerm: searchTerm != null ? searchTerm : ''
    }));
  }, []);

  const handleFilterDataChange = useCallback((val, filterkey) => {
    const filtersToUpdate = cloneDeep(filters);
    const selectedFilter = filtersToUpdate?.find((filter) => filter?.key === filterkey);
    if (selectedFilter) {
      selectedFilter.value = Array.isArray(val) ? val : [val]
    }
    setFilters(filtersToUpdate);
    chargerListCallback?.(orgId, filtersToUpdate, '');
  }, [filters, chargerListCallback, setFilters]);


  function arraysAreEqual<T>(arr1?: T[], arr2?: T[]): boolean {
    if (!arr1 || !arr2 || arr1?.length !== arr2?.length ) {
      return false;
    }
    return arr1.every((value, index) => value === arr2[index]);
  }


  const disableSubmitButton = useCallback(() => {
    if (mode == 'View') { return true }
    if (mode == 'Edit') {
      if (selectedChargers && selectedChargers.length == 0) {
        return true
      }
      if (advanceRuleFormData.description?.length == 0) {
        return true
      }
      if ((!advanceRuleFormData?.executionThreshold || advanceRuleFormData?.executionThreshold < 1  || advanceRuleFormData?.executionThreshold > 50)){
        return true;
      }

      if(resetPeriodErrorMessage!='') return true;

      if(advanceRuleFormData?.autoAssign === 'Enabled' && (advanceRuleFormData?.autoAssignCustomerIds?.length === 0 || advanceRuleFormData?.autoAssignProductTypeIds?.length === 0)) return true;

      const result = (advanceRuleFormData?.name == initialRuleFormDataRef?.current?.name) &&
        (advanceRuleFormData?.description == initialRuleFormDataRef?.current?.description) &&
        (arraysAreEqual(selectedChargers, selectedChargersInitially)) &&
        (advanceRuleFormData?.autoAssign == initialAutoAssignState) &&
        (selectedRadioOptionForStatus == initialRuleFormDataRef?.current?.status) &&
        isEqual(initialExecutionPlan, advanceRuleEngineFormRedux?.executionPlan) && 
        (advanceRuleFormData?.executionThreshold == initialRuleFormDataRef?.current?.executionThreshold)  && 
        (advanceRuleFormData?.resetTimePeriod == initialRuleFormDataRef?.current?.resetTimePeriod) && 
        (advanceRuleFormData?.resetTimeUnit == initialRuleFormDataRef?.current?.resetTimeUnit) && 
        (arraysAreEqual(advanceRuleFormData?.autoAssignCustomerIds,initialRuleFormDataRef?.current?.autoAssignCustomerIds)) && 
        (arraysAreEqual(advanceRuleFormData?.autoAssignProductTypeIds,initialRuleFormDataRef?.current?.autoAssignProductTypeIds))

      // && 
      // !(selectedChargers && selectedChargers?.length > 0);
      return result
    }

    return !((advanceRuleEngineFormRedux?.name) && (advanceRuleEngineFormRedux?.name?.length > 0 && advanceRuleEngineFormRedux?.name?.length < 91) && (advanceRuleEngineFormRedux?.description) && (advanceRuleEngineFormRedux?.description?.length > 0 && advanceRuleEngineFormRedux?.description?.length < 501) && (selectedChargers && selectedChargers?.length > 0) && (advanceRuleEngineFormRedux?.executionPlan) && (advanceRuleEngineFormRedux?.executionThreshold && advanceRuleEngineFormRedux?.executionThreshold >= 1  && advanceRuleEngineFormRedux?.executionThreshold <= 50) && !(resetPeriodErrorMessage !== '') && (advanceRuleFormData?.autoAssign === 'Disabled' || (advanceRuleFormData?.autoAssignCustomerIds?.length > 0 && advanceRuleFormData?.autoAssignProductTypeIds?.length > 0)));
  }, [selectedChargers, advanceRuleEngineFormRedux, advanceRuleFormData, selectedRadioOptionForStatus, mode,resetPeriodErrorMessage,initialAutoAssignState,selectedChargersInitially]);


  const handleSubmit = useCallback(async (mode, draftStatus) => {
    setShowLoader(true);

    const conditions = {};

    advanceRuleFormData?.executionPlan?.trigger?.conditions?.forEach((condition,idx) => {
      const key = condition?.triggerCondName
      conditions[key] = {
        triggerCondName: condition?.triggerCondName,
        triggerCondIdx: idx,
        triggerParamId: condition?.triggerParamId,
        triggerParamLabel: condition?.triggerParamLabel,
        triggerParamType: condition?.triggerParamType,
        triggerParamLevel: condition?.triggerParamLevel,
        triggerOperator: condition?.triggerOperator,
        triggerParameter1Value: condition?.triggerParameter1Value,
        triggerParameter2Value: condition?.triggerParameter2Value,
        isTriggerParamTypeEnum: condition?.isTriggerParamTypeEnum,
        isTriggerParamTypeDate: condition?.isTriggerParamTypeDate,
        isDerived: condition?.isDerived,
        connectorType: condition?.connectorType,
        connectorScope: condition?.connectorScope,
        triggerParamEnumValue: condition?.triggerParamEnumValue ?? [],
        triggerParamUnit: condition?.triggerParamUnit ?? null,
        arithmeticParamId: condition?.arithmeticParamId,
        arithmeticParamLabel: condition?.arithmeticParamLabel,
        arithmeticParamType: condition?.arithmeticParamType,
        arithmeticParamLevel: condition?.arithmeticParamLevel,
        arithmeticOperator: condition?.arithmeticOperator,
        arithmeticParamValue: condition?.arithmeticParamValue,
        arithmeticParamUnit: condition?.arithmeticParamUnit ?? null,
        connective: condition?.connective
      }
    })

    const triggerProperties = advanceRuleFormData?.executionPlan?.triggerType === 'parameter' ? {
      occurrenceLogic: advanceRuleFormData?.executionPlan?.trigger?.occurrenceLogic,
      numberOfOccurrences: advanceRuleFormData?.executionPlan?.trigger?.numberOfOccurrences,
      timePeriod: advanceRuleFormData?.executionPlan?.trigger?.timePeriod,
      timeUnit: advanceRuleFormData?.executionPlan?.trigger?.timeUnit,
      expression: advanceRuleFormData?.executionPlan?.trigger?.expression,
      conditions: conditions,
      isConsecutive: advanceRuleFormData?.executionPlan?.trigger?.isConsecutive,
      waitTimePeriod: advanceRuleFormData?.executionPlan?.trigger?.waitTimePeriod,
      waitTimeUnit: advanceRuleFormData?.executionPlan?.trigger?.waitTimeUnit
    } : 
    {
      occurrenceLogic: 'Scheduled',
      scheduleType: advanceRuleFormData?.executionPlan?.scheduleTime?.scheduleType,
      scheduleDateTime: advanceRuleFormData?.executionPlan?.scheduleTime?.dateTime, 
      recurrenceDays: advanceRuleFormData?.executionPlan?.scheduleTime?.recurrenceDays,
      recurrenceRange: advanceRuleFormData?.executionPlan?.scheduleTime?.recurrenceRange,
      recurrenceCount: advanceRuleFormData?.executionPlan?.scheduleTime?.recurrenceCount,
      endDate: advanceRuleFormData?.executionPlan?.scheduleTime?.endDate,
    }


    const reqBody = {
      id: advanceRuleEngineFormRedux?.id || location?.state?.ruleId || null,
      ruleName: advanceRuleFormData?.name,
      description: advanceRuleFormData?.description,
      // executionPlan: advanceRuleFormData?.executionPlan,
      chargerIds: advanceRuleFormData?.chargerIds != null ? advanceRuleFormData?.chargerIds : selectedChargers,
      status: selectedRadioOptionForStatus,
      draftStatus: draftStatus,
      autoAssign: advanceRuleFormData?.autoAssign != null ? advanceRuleFormData?.autoAssign : 'Disabled',
      fileName: advanceRuleFormData?.fileName,
      imageURL: advanceRuleFormData?.imageURL,
      ...triggerProperties,
      actions: advanceRuleFormData?.executionPlan?.actions,
      conditionBlocks: advanceRuleFormData?.executionPlan?.conditionBlocks,
      executionThreshold: advanceRuleFormData?.executionThreshold,
      resetTimePeriod: advanceRuleFormData?.resetTimePeriod,
      resetTimeUnit: advanceRuleFormData?.resetTimeUnit,
      autoAssignCustomerIds: advanceRuleFormData?.autoAssignCustomerIds?.filter(item => item != 'all'),
      autoAssignProductTypeIds: advanceRuleFormData?.autoAssignProductTypeIds?.filter(item => item != 'all')
    }

    const response = mode==='Edit' ? await advanceRuleEngineUpdateRule(reqBody) : await advanceRuleEngineCreateRule(reqBody);

    if(response?.status === 200 || response?.status === 202 ) {
      setShowLoader(false);
      userFormSuccessToast();
      await dispatch(clearAdvanceRuleEngineFormRedux());

      const tableProps = cloneDeep(advanceRuleEngineListTableProps);
      tableProps.sortBy = mode === 'Edit' ? 'updatedAt' : 'createdAt';
      tableProps.order = 'descending';
      await dispatch(setAdvanceRuleEngineListTableProps(tableProps));
      navigate('/rule-engine-advance');
    } else {
      setShowLoader(false);
      formErrorToast(response?.data?.message);
    }
  }, [advanceRuleFormData, mode, selectedRadioOptionForStatus])

  const onSearchTextChange = useCallback((val) => {
    chargerListCallback?.(orgId, filters, val)
  }, [filters]);

  const searchBoxConfiguration = useMemo(() => {
    return {
      searchFieldId: 'user__form_chargers-search-box',
      searchFieldName: 'user__form_chargers-search-box',
      isDisabled: mode === 'View',
      handleSearch: onSearchTextChange,
      searchBoxClassName: 'rule__engine__charger_selection'
    };
  }, [onSearchTextChange, filters, mode]);

  const chargerFilterProps: FilterProp[] = useMemo(() => {
    return [
      {
        filterLabel: 'Customer',
        filterType: 'dropdown',
        filterId: 'Customer',
        filterDropdownProps: {
          selectValue: filters?.find((filter) => filter?.key === 'customer')?.value,
          selectOptions: customerReferenceData ?? [],
          handleSelectOptionChange: (val): void => {
            handleFilterDataChange(val, 'customer')
          },
          selectDropDownId: 'charger-customer-filter-dropdown',
          isMultiSelect: true,
          isDisabled: mode === 'View',
          renderToBody: true
        }
      },
      {
        filterLabel: 'Location',
        filterType: 'dropdown',
        filterId: 'Location',
        filterDropdownProps: {
          selectValue: filters?.find((filter) => filter?.key === 'location')?.value,
          selectOptions: chargerLocationReferenceData ?? [],
          handleSelectOptionChange: (val): void => {
            handleFilterDataChange(val, 'location')
          },
          selectDropDownId: 'charger-location-filter-dropdown',
          isMultiSelect: true,
          isDisabled: mode === 'View',
          renderToBody: true
        }
      },

      {
        filterLabel: 'Charging Station',
        filterType: 'dropdown',
        filterId: 'chargingStationId',
        filterDropdownProps: {
          selectValue: filters?.find((filter) => filter?.key === 'chargingStationId')?.value,
          selectOptions: chargingStationReferenceData ?? [],
          handleSelectOptionChange: (val): void => {
            handleFilterDataChange(val, 'chargingStationId')
          },
          selectDropDownId: 'charger-location-filter-dropdown',
          isMultiSelect: true,
          isDisabled: mode === 'View',
          renderToBody: true
        }
      },
      {
        filterLabel: 'Product Type',
        filterType: 'dropdown',
        filterId: 'ProductType',
        filterDropdownProps: {
          selectValue: filters?.find((filter) => filter?.key === 'productType')?.value,
          selectOptions: chargerProductTypeReferenceData ?? [],
          handleSelectOptionChange: (val): void => {
            handleFilterDataChange(val, 'productType')
          },
          selectDropDownId: 'charger-location-filter-dropdown',
          isMultiSelect: true,
          isDisabled: mode === 'View',
          renderToBody: true
        }
      },
      {
        filterLabel: 'Software Version',
        filterType: 'dropdown',
        filterId: 'softwareVersion',
        filterDropdownProps: {
          selectValue: filters?.find((filter) => filter?.key === 'softwareVersion')?.value,
          selectOptions: softwareVersionReferenceData ?? [],
          handleSelectOptionChange: (val): void => {
            handleFilterDataChange(val, 'softwareVersion')
          },
          selectDropDownId: 'charger-customer-filter-dropdown-rule-engine',
          isMultiSelect: true,
          isDisabled: mode === 'View',
          renderToBody: true
        }
      },

    ]
  }, [chargerLocationReferenceData, customerReferenceData, filters, mode, softwareVersionReferenceData, chargingStationReferenceData, chargerProductTypeReferenceData, handleFilterDataChange]);

  const saveAsDraftDisableCheck = () => {
    if (mode == 'View') { return true }
    return mode === 'Define' ? ((selectedRadioOptionForStatus === 'Disabled' && (disableSubmitButton() === false)) ? false : true) : ((advanceRuleEngineFormRedux?.runningStatus === 'Draft' && selectedRadioOptionForStatus === 'Disabled' && (disableSubmitButton() === false)) ? false : true)
  }

  const footerButtonListDefineMode = useMemo(() => {
    return [
      {
        buttonText: 'Save as draft',
        buttonId: 'draft',
        btnClassName: !saveAsDraftDisableCheck() ? 'primary__btn' : 'primary__btn disabled',
        handleClick: (): void => {
          handleSubmit?.(mode, 'Draft')
        },
        // isDisabled: (selectedRadioOptionForStatus === 'Disabled' && (disableSubmitButton() === false)) ? false : true,
        isDisabled: saveAsDraftDisableCheck(),
        buttonVariant: 'filled',
      },
      {
        buttonText: mode === 'Edit' ? 'Update' : 'Publish',
        buttonId: 'submit',
        btnClassName: disableSubmitButton() ? 'primary__btn disabled' : 'primary__btn',

        handleClick: (): void => {
          handleSubmit?.(mode, 'Not Draft')
        },
        isDisabled: disableSubmitButton(),
        buttonVariant: 'filled',
      },
      {
        buttonText: 'Cancel',
        buttonId: 'cancel',
        btnClassName: 'secondary__btn',
        handleClick: (): void => {
          navigate('/rule-engine-advance')
        },
        buttonVariant: 'outlined',
      },
    ];
  }, [disableSubmitButton, advanceRuleFormData, mode, selectedChargers, selectedRadioOptionForStatus]);


  const footerButtonListEditMode = useMemo(() => {
    const buttons = [
      {
        buttonText: 'Update Draft',
        buttonId: 'draft',
        btnClassName: !saveAsDraftDisableCheck() ? 'primary__btn' : 'primary__btn disabled',
        handleClick: (): void => {
          handleSubmit?.(mode, 'Draft');
        },
        isDisabled: saveAsDraftDisableCheck(),
        buttonVariant: 'filled',
      },
      {
        buttonText: advanceRuleEngineFormRedux?.runningStatus === 'Draft' ? 'Publish' : 'Update',
        buttonId: 'submit',
        btnClassName: disableSubmitButton() ? 'primary__btn disabled' : 'primary__btn',
        handleClick: (): void => {
          handleSubmit?.(mode, 'Not Draft');
        },
        isDisabled: disableSubmitButton(),
        buttonVariant: 'filled',
      },
      {
        buttonText: 'Cancel',
        buttonId: 'cancel',
        btnClassName: 'secondary__btn',
        handleClick: (): void => {
          navigate('/rule-engine-advance');
        },
        buttonVariant: 'outlined',
      },
    ];

    // Filter out the first button if the condition is true
    return advanceRuleEngineFormRedux?.runningStatus !== 'Draft'
      ? buttons.filter((button) => button.buttonId !== 'draft')
      : buttons;
  }, 
  [ disableSubmitButton, saveAsDraftDisableCheck, mode, advanceRuleEngineFormRedux,advanceRuleFormData ]);

  const footerButtonListViewMode = useMemo(() => {
    return [

      {
        buttonText: 'Cancel',
        buttonId: 'cancel',
        btnClassName: 'secondary__btn',
        handleClick: (): void => {
          navigate('/rule-engine-advance')
        },
        buttonVariant: 'outlined',
      },
    ];
  }, []);

  const setHeaderText = useCallback(() => {
    if ((mode == 'View' || mode == 'Edit') && advanceRuleFormData?.name) {
      return advanceRuleFormData?.name
    } else return `${mode} Rule`
  }, [mode, advanceRuleFormData]);


  const handleDuplicateRule = useCallback(async()=>{
    const ruleId = advanceRuleFormDataRef?.current?.id ?? location?.state?.ruleId
    if(!ruleId || mode === 'Define')return;
    const rule = await dispatch(fetchAdvanceRuleEngineRule({id:ruleId}));
    const data = cloneDeep(advanceRuleFormDataRef?.current);
    data.id = null;
    data.name = rule?.name+'-copy';
    data.chargerIds = null;
    data.description = rule?.description;
    data.status = rule?.status;
    data.draftStatus = rule?.draftStatus;
    data.executionPlan = rule?.executionPlan;
    data.autoAssign = 'Disabled';
    data.imageURL = rule?.imageURL;
    data.fileName = rule?.fileName;
    data.runningStatus = null;
    data.executionThreshold = rule?.executionThreshold ?? 50;
    data.resetTimePeriod = null;
    data.resetTimeUnit = null;
    data.autoAssignCustomerIds = [],
    data.autoAssignProductTypeIds = [],
    advanceRuleFormDataRef.current = data;
    setAdvanceRuleFormData(data);
    dispatch(setAdvanceRuleEngineFormRedux(data));
    setChargerCheckboxStates([]);
    setSelectedChargers([]);
    setSelectedChargersInitially([]);
    setChargersChipValues([]);
    setInitialExecutionPlan(rule?.executionPlan);
    setInitialAutoAssignState(data?.autoAssign);
    setSelectedRadioOptionForStatus(data?.status);
    setMode('Define');
  },[location?.state,mode]);

  const getAdvanceRuleEngineUpdateLogs = useCallback(async () => {
      const response = await dispatch(advanceRuleEngineUpdateLogs(location?.state?.ruleId ?? advanceRuleFormDataRef?.current?.id));
      if (response?.status === 'success') {
        setUpdateLogs(response?.data);
      } else {
        setUpdateLogs([]);
      }
    }, [location?.state?.ruleId]);

  const headerActionBtns = renderHeaderActionButtons({
    actionBtns:
      [
        {
          id: 'rule__engine__form__execution__summary__btn',
          isAccessible: mode === 'View',
          headerActionBtnClick: (): void => {
            setIsExecutionSummarySidePopoverOpen(true);
          }
        },
        // {
        //   id: 'rule__engine__form__trigger__logs__btn',
        //   isAccessible: mode === 'View',
        //   headerActionBtnClick: (): void => {
        //     setIsTriggerLogsSidePopoverOpen(true);
        //   }
        // },
        {
          id: 'rule__engine__form__update__logs__btn',
          isAccessible: mode === 'View',
          headerActionBtnClick: (): void => {
            getAdvanceRuleEngineUpdateLogs();
            setIsUpdateLogsSidePopoverOpen(true);
          }
        },
        {
          id: 'rule__engine__form__duplicate__rule__btn',
          isAccessible: mode !== 'Define',
          headerActionBtnClick: (): void => {
            handleDuplicateRule();
          }
        },
      ]
  })

  const advanceRuleFormProps: ICustomFormProps = useMemo(() => {
    return {
      formContainerClassName: 'advance__rule__engine__form',
      formArray: advanceRuleFormArray
    };
  }, [advanceRuleFormArray, userRoleTypeReferenceData, mode, customerReferenceData]);



  const handleSelectedValues = useCallback((selectedChargers, selectedChargerChips, isChecked) => {
    const updatedFormData = { ...advanceRuleFormDataRef?.current, chargerIds: selectedChargers};

    setChargerCheckboxStates(selectedChargers)
    setSelectedChargers(selectedChargers);
    setAdvanceRuleFormData(updatedFormData)
    setChargersChipValues(selectedChargerChips);
    setIsSelectAllChargersChecked(isChecked)
    advanceRuleFormDataRef.current = updatedFormData;
    dispatch(setAdvanceRuleEngineFormRedux(updatedFormData));
  },[]);

  const autoAssignCustomers = useMemo(
    () => (customerReferenceData ?? []).filter(
      (c) => advanceRuleFormData?.autoAssignCustomerIds?.includes(c.id)
    ),
    [customerReferenceData, advanceRuleFormData?.autoAssignCustomerIds]
  );

  const autoAssignProductTypes = useMemo(
    () => (chargerProductTypeReferenceData ?? []).filter(
      (p) => advanceRuleFormData?.autoAssignProductTypeIds?.includes(p.id)
    ),
    [chargerProductTypeReferenceData, advanceRuleFormData?.autoAssignProductTypeIds]
  );

  const advanceRuleEngineCustomerReferenceData = useMemo(()=>{
    return customerReferenceData?.filter(item => item?.name !== 'Undefined Customer')
  },[customerReferenceData])


  const handleAutoAssignConfigChange = useCallback((val, key) => {
    const ids = val?.map(item => item?.id);
    const updatedFormData = { ...advanceRuleFormDataRef?.current, [key]: ids};
    setAdvanceRuleFormData(updatedFormData);
    advanceRuleFormDataRef.current = updatedFormData;
    dispatch(setAdvanceRuleEngineFormRedux(updatedFormData));
  },[])

  
  const radioButtonList = useMemo(()=>[
    { radioButtonLabel: 'All Chargers', radioButtonId: 'AllChargers', isDisabled: mode === 'View' },
    { radioButtonLabel: 'Select Chargers', radioButtonId: 'SelectChargers', isDisabled: mode === 'View' },
  ],[mode]);

  const radioButtonListForStatus = useMemo(()=>[
    { radioButtonLabel: 'Enabled', radioButtonId: 'Enabled', isDisabled: mode === 'View' },
    { radioButtonLabel: 'Disabled', radioButtonId: 'Disabled', isDisabled: mode === 'View' },
  ],[mode]);


  const handleRadioOptionChange = useCallback((_, value) => {
    setSelectedRadioOption(value);
    if (value === 'AllChargers') setSelectedChargers(['ALL'])
    else { setSelectedChargers(chargerCheckboxStates) }
  },[chargerCheckboxStates]);

  const handleRadioOptionChangeForStatus = useCallback((_, value) => {
    setSelectedRadioOptionForStatus(value);
    const updatedFormData = {...advanceRuleFormDataRef?.current,status: value};
    advanceRuleFormDataRef.current = updatedFormData;
    setAdvanceRuleFormData(updatedFormData)
    dispatch(setAdvanceRuleEngineFormRedux(updatedFormData));
  },[]);

  const radioButtonConfiguration = useMemo(() => {
    return {
      radionBtnGrpName: 'user__form_charger_options',
      buttonsList: radioButtonList,
      selectedRadioBtnValue: selectedRadioOption,
      handleSelectedRadioBtnChange: handleRadioOptionChange
    };
  }, [ mode, selectedRadioOption, chargerCheckboxStates]);

  const radioButtonConfigurationForStatus = useMemo(() => {
      return {
        radionBtnGrpName: 'advance__rule__status__options',
        buttonsList: radioButtonListForStatus,
        selectedRadioBtnValue: selectedRadioOptionForStatus,
        handleSelectedRadioBtnChange: handleRadioOptionChangeForStatus
      };
    }, [ mode, selectedRadioOptionForStatus]);


  useEffect(() => {
    const chargerData = chargerListByCustomerByOrg?.map((item) => {
      return {
        header: item?.customerName,
        count: item?.chargers?.length,
        data: item?.chargers?.map((charger) => charger?.visibleId)
      }
    }) || []

    const dataList = chargerData?.flatMap(({ header, count, data }) => [
      (header !== undefined && count !== undefined) ? `${header} (${count})` : '',
      ...data
    ]).filter(item => item !== '');
    const uniqueDataList = Array.from(new Set(dataList));
    setDataList(uniqueDataList)

  }, [chargerListByCustomerByOrg]);

  useEffect(()=>{
    if (advanceRuleEngineFormRedux && advanceRuleEngineFormRedux?.name?.length) {
    setDisableExecutionPlanButton(false);
  } else setDisableExecutionPlanButton(true); 
  },[advanceRuleEngineFormRedux])

  useEffectOnce(()=>{
    chargerListCallback?.(orgId);
    dispatch(fetchChargerLocationReferenceData());
    dispatch(fetchSoftwarVersionReferenceData());
    dispatch(fetchCustomerReferenceData());
    dispatch(fetchChargerProductTypeReferenceData());
    dispatch(fetchUsersReferenceData());
    dispatch(fetchChargerStationReferenceData());
    if((mode === 'Edit' || mode === 'View') && location?.state?.ruleId && location?.state?.fetchRule) {
      dispatch(fetchAdvanceRuleEngineRule({id: location?.state?.ruleId})).then(data => {
        dispatch(setAdvanceRuleEngineFormRedux(data));
        setChargerCheckboxStates(data?.chargerIds);
        setSelectedChargers(data?.chargerIds);
        setSelectedChargersInitially(data?.chargerIds);
        setChargersChipValues(data?.chargerIds);
        setResetPeriodToggle(data?.resetTimePeriod != null);
        setAdvanceRuleFormData({
          id: data?.id,
          name: data?.name,
          description: data?.description,
          chargerIds: data?.chargerIds,
          status: data?.status,
          draftStatus: data?.draftStatus,
          executionPlan: data?.executionPlan,
          autoAssign: data?.autoAssign,
          imageURL: data?.imageURL,
          fileName: data?.fileName,
          runningStatus: data?.runningStatus,
          executionThreshold: data?.executionThreshold,
          resetTimePeriod: data?.resetTimePeriod,
          resetTimeUnit: data?.resetTimeUnit,
          autoAssignCustomerIds: data?.autoAssignCustomerIds,
          autoAssignProductTypeIds: data?.autoAssignProductTypeIds
        })
        initialRuleFormDataRef.current = {
          id: data?.id,
          name: data?.name,
          description: data?.description,
          chargerIds: data?.chargerIds,
          status: data?.status,
          draftStatus: data?.draftStatus,
          executionPlan: data?.executionPlan,
          autoAssign: data?.autoAssign,
          imageURL: data?.imageURL,
          fileName: data?.fileName,
          runningStatus: data?.runningStatus,
          executionThreshold: data?.executionThreshold,
          resetTimePeriod: data?.resetTimePeriod,
          resetTimeUnit: data?.resetTimeUnit,
          autoAssignCustomerIds: data?.autoAssignCustomerIds,
          autoAssignProductTypeIds: data?.autoAssignProductTypeIds
        }
        advanceRuleFormDataRef.current = {
          id: data?.id,
          name: data?.name,
          description: data?.description,
          chargerIds: data?.chargerIds,
          status: data?.status,
          draftStatus: data?.draftStatus,
          executionPlan: data?.executionPlan,
          autoAssign: data?.autoAssign,
          imageURL: data?.imageURL,
          fileName: data?.fileName,
          runningStatus: data?.runningStatus,
          executionThreshold: data?.executionThreshold,
          resetTimePeriod: data?.resetTimePeriod,
          resetTimeUnit: data?.resetTimeUnit,
          autoAssignCustomerIds: data?.autoAssignCustomerIds,
          autoAssignProductTypeIds: data?.autoAssignProductTypeIds
        }
        setInitialExecutionPlan(data?.executionPlan);
        setInitialAutoAssignState(data?.autoAssign);
        setSelectedRadioOptionForStatus(data?.status);
      });
    } else if(advanceRuleEngineFormRedux){
      const data = cloneDeep(advanceRuleFormData);
      data.id = advanceRuleEngineFormRedux?.id ?? null;
      data.executionPlan = advanceRuleEngineFormRedux?.executionPlan;
      data.name = advanceRuleEngineFormRedux?.name
      data.description = advanceRuleEngineFormRedux?.description
      data.imageURL = advanceRuleEngineFormRedux?.imageURL
      data.fileName = advanceRuleEngineFormRedux?.fileName
      data.autoAssign = advanceRuleEngineFormRedux?.autoAssign
      data.status = advanceRuleEngineFormRedux?.status
      data.executionThreshold = advanceRuleEngineFormRedux?.executionThreshold
      data.resetTimePeriod = advanceRuleEngineFormRedux?.resetTimePeriod
      data.resetTimeUnit = advanceRuleEngineFormRedux?.resetTimeUnit
      data.chargerIds = advanceRuleEngineFormRedux?.chargerIds,
      data.autoAssignCustomerIds = advanceRuleEngineFormRedux?.autoAssignCustomerIds,
      data.autoAssignProductTypeIds = advanceRuleEngineFormRedux?.autoAssignProductTypeIds

      if (advanceRuleEngineFormRedux?.chargerIds?.length >= 1) {
        setSelectedChargers(advanceRuleEngineFormRedux?.chargerIds)
        setChargerCheckboxStates(advanceRuleEngineFormRedux?.chargerIds)
        setChargersChipValues(advanceRuleEngineFormRedux?.chargerIds);
      }
      advanceRuleFormDataRef.current = data
      setAdvanceRuleFormData(data);
      setSelectedRadioOptionForStatus(advanceRuleEngineFormRedux?.status);
    }
  });

  const handleSidePopoverExpansion = () => {
    setIsSidePopoverExpanded(prev => !prev);
  }

  const handleCloseExecutionSummaryPopover = () => {
    setIsExecutionSummarySidePopoverOpen(false);
  }

  // const handleCloseTriggerLogsPopover = () => {
  //   setIsTriggerLogsSidePopoverOpen(false);
  // }

  const handleCloseUpdateLogsPopover = () => {
    setIsUpdateLogsSidePopoverOpen(false);
  }


  const handleFiltersClosePopover = (): void => {
    setExecutionSummaryFiltersVisible(false);
  }

  // const handleTriggerLogsFiltersClosePopover = (): void => {
  //   setTriggerLogsFiltersVisible(false);
  // }

  const headerActionExecutionSummaryBtn = renderHeaderActionButtons({
    actionBtns:[
      {
        id: 'add_filter_btn',
        isAccessible: true,
        headerActionBtnClick: (): void => {
          setExecutionSummaryFiltersVisible(true);
        },
        badgeCount: getCurrentScreenAppliedFiltersCount('advanceRuleExecutionSummary', false)
      },
      {
        id: 'export_csv_btn',
        isAccessible: true,
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        headerActionBtnClick: (event): void => {
          setExportAnchorEl(event.currentTarget);
        }
      }
    ]
  })

  // const headerActionTriggerLogsBtn = renderHeaderActionButtons({
  //   actionBtns:[
  //     {
  //       id: 'add_filter_btn',
  //       isAccessible: true,
  //       headerActionBtnClick: (): void => {
  //         setTriggerLogsFiltersVisible(true);
  //       },
  //       badgeCount: getCurrentScreenAppliedFiltersCount('advanceRuleTriggerLogs', false)
  //     },
  //     {
  //       id: 'export_csv_btn',
  //       isAccessible: true,
  //       // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  //       headerActionBtnClick: (event): void => {
  //         setTriggerLogsExportAnchorEl(event.currentTarget);
  //       }
  //     }
  //   ]
  // })

  return (
    <>
      <DashboardLoader showLoader={showLoader} />
      <div className='advance__rule__engine__form__wrap'>
        <CustomBreadCrumbs breadCrumbs={breadCrumbs} />
        <div className='advance__rule__engine__form__wrap-header'>
          <DashboardHeader
            header={setHeaderText()}
            headerClassName='ruleEngine__form__wrap-header-custom'
          />
          {
            mode !== 'Define' && (
              <Icon
                iconClassName={mode === 'View' ? 'rms__pencil__icon' : 'rms__view__icon'}
                containerClassName='org__form_header-edit'
                onIconClick={() => {
                  setMode(mode === 'View' ? 'Edit' : 'View')
                }}
              />

            )
          }
          <div className="rms__table__dashboard-sub-header-wrap">
            {
              <div className='rms__table__dashboard-sub-header-wrap-buttons'>
                <TableSubHeader headerActionBtns={headerActionBtns} />
              </div>
            }
          </div>
        </div>
        <div className='advance__rule__engine__form-content'>
          <CustomForm {...advanceRuleFormProps} />
          <Typography sx={{ fontSize: '16px', marginTop: '5px', marginBottom: '10px', fontWeight: 500, fontFamily: 'Inter, sans-serif' }}>
            Execution Plan
          </Typography>
          {
            mode === 'View' ? (
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 'auto' }}>
                {!isImageLoaded && (
                  <ThreeDots
                    height="40"
                    width="40"
                    radius="9"
                    color="#01BFBF"
                    ariaLabel="three-dots-loading"
                    visible={true}
                  />
                )}
                <img
                  src={advanceRuleFormData?.imageURL}
                  alt="Execution Plan"
                  style={{
                    display: isImageLoaded ? 'block' : 'none',
                    width: '100%',
                    maxWidth: '800px',
                    height: 'auto',
                    borderRadius: '8px',
                    scale: 0.75,
                  }}
                  onLoad={() => setIsImageLoaded(true)}
                />
              </div>
            ) : (
              <ExecutionPlanButton
                executionPlanMode={advanceRuleFormData?.executionPlan != null ? 'Edit' : 'Define'}
                mode={mode}
                ruleId={location?.state?.ruleId ?? advanceRuleEngineFormRedux?.id}
                disabled={disableExecutionPlanButton}
              />
            )}
          
          <div className='advance__rule__engine__circuit__breaker__threshold-header'>
            <div className='advance__rule__engine__circuit__breaker__threshold-header-label'>Circuit Breaker *</div>
            <IconWithTooltip iconClassName={'rms_info_icon-black '} toolTipText={'Info: Applies when a rule executes X times on the same charger/connector within a 24-hour window (12:00 AM – 11:59 PM IST).'} />
          </div>

          <div className='advance__rule__engine__circuit__breaker__threshold__container'>
            <div className='advance__rule__engine__circuit__breaker__threshold-label'>Stop rule execution after</div>
            <div className='advance__rule__engine__circuit__breaker__threshold-value-container'>
              <CustomInput 
                inputValue={advanceRuleFormData?.executionThreshold != null ? advanceRuleFormData?.executionThreshold : ''} 
                inputFieldId={''} 
                className={'advance__rule__engine__cb__threshold__container'}
                isRequired={true} 
                isDisabled = {mode === 'View'}
                handleKeyPress={(e) => {
                  if (['.', '+', '-', 'e'].includes(e.key)) {
                    e.preventDefault();
                    toast.warn('Only digits are allowed');
                  }
                }}
                handleInputChange={
                  (event)=>{
                    const val = event?.target?.value;
                    if( val && isNaN(parseInt(val)) ) return;
                    if( !val || val < 1 || val > 50) {
                      setCbErrorMessage('Execution threshold value must be in range [1,50].');
                    } 
                    else setCbErrorMessage('');
                    const value = val ? parseInt(val) : null;
                    handleFormDataChange(value,'executionThreshold');
                  }
                }
              />
            </div>
            <div className='advance__rule__engine__circuit__breaker__threshold-label'>executions within a day.</div>
          </div>

          <div className='advance__rule__engine__circuit__breaker__threshold-value-error-msg'>
            {cbErrorMessage}
          </div>

          <div className='advance__rule__engine__circuit__breaker__threshold-header'>
            <div className='advance__rule__engine__circuit__breaker__threshold-header-label'>Rule Reset</div>
            <IconWithTooltip iconClassName={'rms_info_icon-black '} toolTipText={'Resets the rule when the trigger condition remains false for the set duration. Applies only after the rule execution is completed for the specific charger/connector.'} />
            <div className='advance__rule__engine__reset__period__enable__switch'>
              <CustomSwitch  
                checked={resetPeriodToggleConfig?.checked}
                handleClick={resetPeriodToggleConfig?.handleClick}
                isDisabled={resetPeriodToggleConfig?.isDisabled} 
                switchId={'advance__rule__engine__reset__period__enable-switch'}              
              />
            </div>
          </div>

          {
            resetPeriodToggle && <>
              <div className='advance__rule__engine__circuit__breaker__threshold__container'>
                <div className='advance__rule__engine__circuit__breaker__threshold-label'>Rule re-executes after</div>
                <div className='advance__rule__engine__circuit__breaker__threshold-value-container'>
                  <CustomInput 
                    inputValue={advanceRuleFormData?.resetTimePeriod != null ? advanceRuleFormData?.resetTimePeriod : ''} 
                    inputFieldId={''} 
                    className={'advance__rule__engine__reset__time__period__container'}
                    isRequired={false} 
                    isDisabled = {mode === 'View'}
                    handleKeyPress={(e) => {
                      if (['.', '+', '-', 'e'].includes(e.key)) {
                        e.preventDefault();
                        toast.warn('Only digits are allowed');
                      }
                    }}
                    handleInputChange={
                      (event)=>{
                        const val = event?.target?.value;
                        if( val && isNaN(parseInt(val)) ) return;
                        if( !val || val < 1 || val > 9999) {
                          setResetPeriodErrorMessage('Reset period value must be in range [1,9999].');
                        } 
                        else setResetPeriodErrorMessage('');
                        const value = val ? parseInt(val) : null;
                        handleFormDataChange(value,'resetTimePeriod');
                      }
                    }
                  />
                </div>
                <div className='advance__rule__engine__reset__time__unit-container'>
                  <SelectDropDown 
                    selectDropDownId={'advance__rule__engine__reset__time__unit-dropdown'} 
                    dropDownClassName={'advance__rule__engine__reset__time__unit-dropdown'}
                    selectValue={resetTimeUnitRef.find(item => item.id === advanceRuleFormData?.resetTimeUnit) ?? null}
                    handleSelectOptionChange={(val)=>{
                      handleFormDataChange(val?.id,'resetTimeUnit');
                    }} 
                    isDisabled={mode === 'View' || advanceRuleFormData?.resetTimePeriod === null}
                    selectOptions={resetTimeUnitRef} 
                  />
                </div>
              </div>

              <div className='advance__rule__engine__circuit__breaker__threshold-value-error-msg'>
                {resetPeriodErrorMessage}
              </div>
            </>
          }

          <CustomRadioForm
            smallerFont={true}
            formContainerClass={'user__form__charger-selection'}
            header={'Charger Selection'}
            dataList={dataList || []}
            individualCheckboxStates={chargerCheckboxStates}
            selectedChipValues={chargersChipValues}
            selectAllChecked={isSelectAllChargersChecked}
            handleSelectedData={handleSelectedValues}
            filterProps={chargerFilterProps}
            radioButtonConfiguration={radioButtonConfiguration}
            searchBoxConfiguration={searchBoxConfiguration}
            disableCheckBox={mode === 'View'}
            showRadioList={selectedRadioOption === 'SelectChargers'}
            isCustom={true}
            radioButtonConfigNotRequired={true}
            removePadding={true}
          />

        <div className='user__form__wrap-footer-top'>
          <div className='user__form__wrap-footer-top-checkbox' onClick={() => { mode !== 'View' && handleFormDataChange(advanceRuleFormData?.autoAssign === 'Enabled' ? 'Disabled' : 'Enabled', 'autoAssign') }} >
            <CheckBox checked={advanceRuleFormData?.autoAssign === 'Enabled'} isDisabled={mode === 'View'} />
            Auto assign new charger to this rule
          </div>
          <IconWithTooltip iconClassName='rms_info_icon-black' toolTipText={'RMS will automatically assign any new charger to this rule.'} containerClassName='user__form_footer-auto-assign-info' />
        </div>

        {
          advanceRuleFormData?.autoAssign === 'Enabled' && <div className='rule_engine_form_auto__assign__config'>
            <div className='auto__assign__config__label advance__rule__engine__circuit__breaker__threshold-header-label'>Auto assign configuration</div>
            <div className='auto__assign__config__body'>
                <div className='auto__assign__config_selection'>
                  <div className='auto__assign__config__dropdown__label'>Customer*</div>
                  <div className='auto__assign__config__dropdown'>
                    <SelectDropDown 
                      selectDropDownId={'auto__assign__config_customer_selection-dropdown'} 
                      dropDownClassName={'auto__assign__config__dropdown'}
                      selectValue={autoAssignCustomers}
                      handleSelectOptionChange={(val) => handleAutoAssignConfigChange(val,'autoAssignCustomerIds')} 
                      selectOptions={advanceRuleEngineCustomerReferenceData ?? []} 
                      isMultiSelect={true}
                      renderToBody={true}
                      isDisabled = {mode === 'View'}
                    />
                  </div>
                </div>
                <div className='auto__assign__config_selection'>
                  <div className='auto__assign__config__dropdown__label'>Product Type*</div>
                  <div className='auto__assign__config__dropdown'>
                    <SelectDropDown 
                      selectDropDownId={'auto__assign__config_product_type_selection-dropdown'} 
                      dropDownClassName={'auto__assign__config__dropdown'}
                      selectValue={autoAssignProductTypes}
                      handleSelectOptionChange={(val) => handleAutoAssignConfigChange(val,'autoAssignProductTypeIds')} 
                      selectOptions={chargerProductTypeReferenceData ?? []} 
                      isMultiSelect={true}
                      renderToBody={true}
                      isDisabled = {mode === 'View'}
                    />
                  </div>
                </div>
            </div>
         </div>
        }

        <div style={{ marginLeft: '5px' }}>
          <Typography sx={{ fontSize: '16px', fontWeight: 500, mt: '20px', mb: '10px', fontFamily: 'Inter, sans-serif' }}>
            Enable/Disable
          </Typography>
          <RadioButton
            key={'advanceRuleStatus' + selectedRadioOptionForStatus}
            buttonsList={radioButtonConfigurationForStatus?.buttonsList}
            handleSelectedRadioBtnChange={radioButtonConfigurationForStatus?.handleSelectedRadioBtnChange}
            selectedRadioBtnValue={radioButtonConfigurationForStatus?.selectedRadioBtnValue}
            radionBtnGrpName={radioButtonConfigurationForStatus?.radionBtnGrpName}
          />
        </div>


        <div className='user__form__wrap-footer'>
          <CustomButtonGroup
            buttonsList={
              mode === 'View'
                ? footerButtonListViewMode
                : mode === 'Define'
                  ? footerButtonListDefineMode
                  : footerButtonListEditMode
            }
            buttonGroupClassName='button__group__footer'
          />
        </div>

        </div>
      </div>

      {
        isExecutionSummarySidePopoverOpen && <SidePopover
            id='advance__rule__engine__form__execution__summary__side__popover'
            open={isExecutionSummarySidePopoverOpen}
            headerText={'Execution Summary'}
            headerSecondaryText={`Rule: ${advanceRuleFormData?.name}`}
            containerClassName='advance__rule__engine__detail__popover'
            handleClose={() => { }}
            headerClassName={'add__rule__engine__header__config'}
            horizontalLinePopover={true}
            popperClassName={isSidePopoverExpanded ? 'advance__rule__engine__form__side__popover__expanded' : 'advance__rule__engine__form__side__popover'}
            isRuleEnginePopOver={true}
            showExpandableIcon={true}
            ruleEngineSidePopoverOnclose={handleCloseExecutionSummaryPopover}
            isSidePopOverExpanded={isSidePopoverExpanded}
            handleSidePopOverExpansion={handleSidePopoverExpansion}
            headerActionBtns={headerActionExecutionSummaryBtn}
            secondaryHeaderRightContent={
              <div className='toggle__switch__config'>
                <IconWithTooltip
                  iconClassName='rms_info_icon-black'
                  toolTipText='Shows all trigger logs with no action controls and initial trigger failures during rule creation or update are shown.'
                  containerClassName='dasboard-toggle-switch-info'
                />
                <CustomSwitch
                  switchId='execution__summary__show__all__triggers__switch'
                  switchClassName='execution__summary__show__all__triggers__switch'
                  checked={showAllTriggers}
                  disableSwitchLabelName='All Trigger Logs'
                  handleClick={() => setShowAllTriggers(prev => !prev)}
                  isDisabled={false}
                />
              </div>
            }
            // eslint-disable-next-line react/no-children-prop
            children={
              <>
                {
                  <ExecutionSummaryPopover
                    ruleId={location?.state?.ruleId ?? advanceRuleEngineFormRedux?.id}
                    executionSummaryFiltersVisible={executionSummaryFiltersVisible}
                    handleFiltersClosePopover={handleFiltersClosePopover}
                    exportAnchor={[exportAnchorEl,setExportAnchorEl]}
                    showAllTriggers={showAllTriggers}
                    setShowAllTriggers={setShowAllTriggers}
                  />

                }
              </>
            }
          />
      }

      {
        isUpdateLogsSidePopoverOpen && <SidePopover
            id='advance__rule__engine__form__execution__summary__side__popover'
            open={isUpdateLogsSidePopoverOpen}
            headerText={'Update Logs'}
            headerSecondaryText={`Rule: ${advanceRuleFormData?.name}`}
            containerClassName='advance__rule__engine__detail__popover'
            handleClose={() => { }}
            headerClassName={'add__rule__engine__header__config'}
            horizontalLinePopover={true}
            popperClassName={isSidePopoverExpanded ? 'advance__rule__engine__form__side__popover__expanded' : 'advance__rule__engine__form__side__popover'}
            isRuleEnginePopOver={true}
            showExpandableIcon={true}
            ruleEngineSidePopoverOnclose={handleCloseUpdateLogsPopover}
            isSidePopOverExpanded={isSidePopoverExpanded}
            handleSidePopOverExpansion={handleSidePopoverExpansion}
            // eslint-disable-next-line react/no-children-prop
            children={
              <>
                {
                  <UpdateLogsSidePopover
                    ruleId = {location?.state?.ruleId ?? advanceRuleEngineFormRedux?.id}
                    updateLogs={updateLogs}
                  />
                }
              </>
            }
          />
      }

      {/* {
        isTriggerLogsSidePopoverOpen && <SidePopover
            id='advance__rule__engine__form__trigger__logs__side__popover'
            open={isTriggerLogsSidePopoverOpen}
            headerText={'Trigger Logs'}
            headerSecondaryText={`Rule: ${advanceRuleFormData?.name}`}
            containerClassName='advance__rule__engine__detail__popover'
            handleClose={() => { }}
            headerClassName={'add__rule__engine__header__config'}
            horizontalLinePopover={true}
            popperClassName={isSidePopoverExpanded ? 'advance__rule__engine__form__side__popover__expanded' : 'advance__rule__engine__form__side__popover'}
            isRuleEnginePopOver={true}
            showExpandableIcon={true}
            ruleEngineSidePopoverOnclose={handleCloseTriggerLogsPopover}
            isSidePopOverExpanded={isSidePopoverExpanded}
            handleSidePopOverExpansion={handleSidePopoverExpansion}
            headerActionBtns={headerActionTriggerLogsBtn}
            // eslint-disable-next-line react/no-children-prop
            children={
              <>
                {
                  <TriggerLogsPopover
                    ruleId={location?.state?.ruleId ?? advanceRuleEngineFormRedux?.id}
                    triggerLogsFiltersVisible={triggerLogsFiltersVisible}
                    handleFiltersClosePopover={handleTriggerLogsFiltersClosePopover}
                    exportAnchor={[triggerLogsExportAnchorEl, setTriggerLogsExportAnchorEl]}
                  />
                }
              </>
            }
          />
      } */}
    </>
  )
}



export default AdvanceRuleEngineForm